import { render, staticRenderFns } from "./settings-lines-pane.vue?vue&type=template&id=512607ee&scoped=true"
import script from "./settings-lines-pane.vue?vue&type=script&lang=js"
export * from "./settings-lines-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-lines-pane.vue?vue&type=style&index=0&id=512607ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512607ee",
  null
  
)

export default component.exports